import { getListFreespin } from '../api/getListFreespin';
import {setGetListFreespinAction} from '../action';

const setGetListFreespin = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getListFreespin(params);

            if (data.status === 'success') {
                dispatch(setGetListFreespinAction({
                    data: data.data.list,
                    countPage: data.data.countPage
                }));
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetListFreespin
}